import React, { useState } from "react";
import styles from "./FormSettingsPage.module.css";
import Header from "../../components/header/Header";
import Overview from "../../components/formSettings/overview/Overview";

const FormSettingsPage = () => {
  const showNavigation = true;

  const [showFullList, toggleShowFullList] = useState(true);
  const [insertForm, toggleInsertForm] = useState(false);
  const [deleteForm, toggleDeleteForm] = useState(false);
  const [reloadAll, toggleReloadAll] = useState(false);
  const [displayContainer, toggleDisplayContainer] = useState(false);
  const [route, setRoute] = useState("subheadings");

  function displaySubheadings() {
    setRoute("subheadings");
    resetDisplay();
  }

  function displayCountries() {
    setRoute("countries");
    resetDisplay();
  }

  function displayPublishers() {
    setRoute("publishers");
    resetDisplay();
  }

  function displayPublishers2() {
    setRoute("publishers2");
    resetDisplay();
  }

  function resetDisplay() {
    toggleReloadAll(true);
    toggleShowFullList(true);
    toggleDisplayContainer(false);
    toggleInsertForm(false);
    toggleDeleteForm(false);
  }

  return (
    <div>
      <Header showNavigation={showNavigation} />

      <div className={styles["manage-settings-page-container"]}>
        <div className={styles["menu-form-wrapper"]}>
          <div className={styles["menu-container"]}>
            <h3 onClick={displaySubheadings}>Form Settings</h3>
            <button
              className={styles["form-settings-menu-button"]}
              onClick={displaySubheadings}
            >
              Specsheets list subheadings
            </button>
            <button
              className={styles["form-settings-menu-button"]}
              onClick={displayCountries}
            >
              Countries
            </button>
            <button
              className={styles["form-settings-menu-button"]}
              onClick={displayPublishers}
            >
              Publishers <span className={styles["ds-version1"]}>(DS1)</span>
            </button>
            <button
              className={styles["form-settings-menu-button"]}
              onClick={displayPublishers2}
            >
              Publishers <span className={styles["ds-version2"]}>(DS2)</span>
            </button>
          </div>

          <div className={styles["line-divider"]}></div>
          <div className={styles["settings-container"]}>
            {route === "subheadings" && (
              <Overview
                showFullList={showFullList}
                toggleShowFullList={toggleShowFullList}
                insertForm={insertForm}
                toggleInsertForm={toggleInsertForm}
                deleteForm={deleteForm}
                toggleDeleteForm={toggleDeleteForm}
                reloadAll={reloadAll}
                toggleReloadAll={toggleReloadAll}
                displayContainer={displayContainer}
                toggleDisplayContainer={toggleDisplayContainer}
                route={route}
              />
            )}

            {route === "countries" && (
              <Overview
                showFullList={showFullList}
                toggleShowFullList={toggleShowFullList}
                insertForm={insertForm}
                toggleInsertForm={toggleInsertForm}
                deleteForm={deleteForm}
                toggleDeleteForm={toggleDeleteForm}
                reloadAll={reloadAll}
                toggleReloadAll={toggleReloadAll}
                displayContainer={displayContainer}
                toggleDisplayContainer={toggleDisplayContainer}
                route={route}
              />
            )}

            {route === "publishers" && (
              <Overview
                showFullList={showFullList}
                toggleShowFullList={toggleShowFullList}
                insertForm={insertForm}
                toggleInsertForm={toggleInsertForm}
                deleteForm={deleteForm}
                toggleDeleteForm={toggleDeleteForm}
                reloadAll={reloadAll}
                toggleReloadAll={toggleReloadAll}
                displayContainer={displayContainer}
                toggleDisplayContainer={toggleDisplayContainer}
                route={route}
              />
            )}

            {route === "publishers2" && (
              <Overview
                showFullList={showFullList}
                toggleShowFullList={toggleShowFullList}
                insertForm={insertForm}
                toggleInsertForm={toggleInsertForm}
                deleteForm={deleteForm}
                toggleDeleteForm={toggleDeleteForm}
                reloadAll={reloadAll}
                toggleReloadAll={toggleReloadAll}
                displayContainer={displayContainer}
                toggleDisplayContainer={toggleDisplayContainer}
                route={route}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormSettingsPage;
